import { Injectable } from '@angular/core';

const STORAGE_KEY = 'slm.loginReturnUrl';
// Room for a doc hub hand-off whose 2048-character return path is encoded twice inside returnUrl.
const MAX_LENGTH = 8192;

const isUnsafeChar = (c: string): boolean => c === '\\' || c < ' ' || c === '\u007f';

/** Only a path inside the app, so a stored value can never send the user to another site. */
export function isAppPath(url: unknown): url is string {
  return (
    typeof url === 'string' &&
    url.length <= MAX_LENGTH &&
    url.startsWith('/') &&
    !url.startsWith('//') &&
    ![...url].some(isUnsafeChar)
  );
}

/** Keeps the requested page through SSO, MFA and new-password steps, which all drop the returnUrl query. */
@Injectable({ providedIn: 'root' })
export class LoginReturnUrlService {
  save(url: string | null | undefined): void {
    if (!isAppPath(url) || url === '/') {
      this.clear();
      return;
    }
    try {
      sessionStorage.setItem(STORAGE_KEY, url);
    } catch {
      // Storage blocked: the user lands on the home page, as before.
    }
  }

  /** Returns the saved path once, then forgets it. */
  take(): string | null {
    try {
      const url = sessionStorage.getItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);
      return isAppPath(url) ? url : null;
    } catch {
      return null;
    }
  }

  clear(): void {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      // Nothing to clear when storage is blocked.
    }
  }
}
